"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
var Router_helper_1 = require("../../../helpers/Router.helper");
function Link(_a) {
    var __deps__ = _a.__deps__, href = _a.href, props = __rest(_a, ["__deps__", "href"]);
    var normalizedHref = Router_helper_1.RouterHelper.normalizeHref(href);
    var isDisabled = props["data-disabled"];
    var customEventKey = props.customEventKey;
    if (props.noServerSideHtml) {
        return __deps__.createElement("div", __assign(__assign({}, props), { onClick: function (ev) {
                if (customEventKey) {
                    // Prevent default behaviour
                    ev.preventDefault();
                    var customEvent = new CustomEvent(customEventKey, {
                        detail: { href: href, originalEvent: ev },
                    });
                    // Dispatch the custom event on the current target
                    window.dispatchEvent(customEvent);
                    // Stop further onClick execution
                    return;
                }
                props.onClick && props.onClick();
                Router_helper_1.RouterHelper.onClickLinkEventHandler(ev);
            } }));
    }
    else {
        return __deps__.createElement("a", __assign(__assign({}, props), { href: !isDisabled ? normalizedHref : undefined, onClick: function (ev) {
                if (customEventKey) {
                    // Prevent default behaviour
                    ev.preventDefault();
                    var customEvent = new CustomEvent(customEventKey, {
                        detail: { href: href, originalEvent: ev },
                    });
                    // Dispatch the custom event on the current target
                    window.dispatchEvent(customEvent);
                    // Stop further onClick execution
                    return;
                }
                props.onClick && props.onClick();
                Router_helper_1.RouterHelper.onClickLinkEventHandler(ev);
            } }));
    }
}
exports.Link = Link;
